import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=7f0ba188&scoped=true"
import script from "./WelcomeVideo.vue?vue&type=script&lang=js"
export * from "./WelcomeVideo.vue?vue&type=script&lang=js"
import style0 from "./WelcomeVideo.vue?vue&type=style&index=0&id=7f0ba188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ba188",
  null
  
)

export default component.exports